import {
    LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR,
    LOAD_METRICS_FOR_FLOOR_CALL_BEGIN,
    LOAD_METRICS_FOR_FLOOR_CALL_FAILURE,
    LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR,
    LOAD_STOW_CART_DATA_FOR_FLOOR,
    LOAD_STOW_FLOOR_DATA_FOR_FLOOR,
    LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR
} from "../actions/FloorActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    inductPackageMetricsMap: {},
    pickPackageMetricsMap: {},
    stowCartData: {},
    stowFloorsData: {},
    stowPackageMetricsMap: {}
}

/**
 * Reducer function for Floor View that changes state
 * based on the action triggered.
 */
export default function floorReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_FLOOR_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMap: action.inductPackageMetricsMap
            };
        case LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR:
            return {
                ...state,
                loading: false,
                pickPackageMetricsMap: action.pickPackageMetricsMap
            };
        case LOAD_STOW_CART_DATA_FOR_FLOOR:
            return {
                ...state,
                loading: false,
                stowCartData: {
                    ...state.stowCartData,
                    [action.stowCartData.floor]: action.stowCartData.cartData
                }
            };
        case LOAD_STOW_FLOOR_DATA_FOR_FLOOR:
            return {
                ...state,
                loading: false,
                stowFloorsData: action.stowFloorsData
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_METRICS_FOR_FLOOR_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/FloorReducer.js